function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "23760CF3-BDEF-4C94-ADBF-195770E90005");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "search_page-loading",
  transform: "translate(-685.000000, -294.000000)",
  fill: "#FEB756",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M720.5,294 C739.910048,294 755.681751,309.577603 755.995244,328.912943 L756,329.5 L750,329.5 C750,313.2076 736.7924,300 720.5,300 C704.2076,300 691,313.2076 691,329.5 C691,345.629476 703.944769,358.73554 720.012164,358.996048 L720.5,359 L720.5,365 C700.893891,365 685,349.106109 685,329.5 C685,309.893891 700.893891,294 720.5,294 Z",
  id: "loading_spinner"
})));

var SvgLoadingSpinnerImage = function SvgLoadingSpinnerImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "71px",
    viewBox: "0 0 71 71",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoadingSpinnerImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loadingSpinnerImage.97acc53e.svg";
export { ForwardRef as ReactComponent };